import { ArrowLeftThin } from '@ori-ui/icons';
import { ButtonBase, styled } from '@ori-ui/mui';
import type { MouseEvent, FC } from 'react';
import React, { useCallback } from 'react';

interface BackButtonProps {
  label: string;
  onClick: (event: MouseEvent) => void;
}

const StyledBackButton = styled(ButtonBase)(({ theme }) => ({
  alignItems: 'center',
  alignSelf: 'center',
  cursor: 'pointer',
  display: 'flex',
  fontWeight: theme.typography.fontWeightBold,
  height: '80px',
  justifyContent: 'center',
  margin: theme.spacing(0, 2),
  paddingTop: '20px',
  verticalAlign: 'middle',
  '&:hover': {
    color: theme.palette.secondary.main,
  },
  [theme.breakpoints.up(768)]: {
    height: 'auto',
    margin: theme.spacing(0, 3),
    paddingTop: 0,
  },
}));

export const BackButton: FC<BackButtonProps> = ({ label, onClick }) => {
  const clickHandler = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();
      onClick(event);
    },
    [onClick],
  );

  return (
    <StyledBackButton
      disableRipple
      onClick={clickHandler}
    >
      <ArrowLeftThin />
      <span>{label}</span>
    </StyledBackButton>
  );
};
